import React from "react";
import { useTranslation } from "react-i18next";
import { Option } from "react-select/lib/filters";
import AdvanceSelector from "../advance-selector";
import useGetCampusOptions from "@modules/shared/selectors/hooks/useGetCampusOptions";
import { SelectPagination } from "@foris/avocado-suite";

interface AdvanceCampusSelectorProps {
  scenario: string;
  campusOption?: Option;
  isSimpleSelector?: boolean;
  isDisabled?: boolean;
  isOptionDisabled?: (option: any) => boolean;
  onChange?: (option: Option) => void;
}

const AdvanceCampusSelector = ({
  scenario,
  campusOption,
  isSimpleSelector = false,
  isDisabled = false,
  isOptionDisabled,
  onChange,
}: AdvanceCampusSelectorProps) => {
  const { loadOptions } = useGetCampusOptions({ scenario });
  const { t } = useTranslation();

  return isSimpleSelector ? (
    <SelectPagination
      label={t("advanced-search.classroom.forms.campus.select-value.input-label")}
      value={campusOption}
      placeholder={t("advanced-search.classroom.forms.campus.select-value.placeholder")}
      loadOptions={loadOptions}
      onChange={onChange}
      isOptionDisabled={isOptionDisabled}
      disabled={isDisabled}
    />
  ) : (
    <AdvanceSelector
      isPaginated
      dimension={t("advanced-search.classroom.forms.campus.select-property.placeholder")}
      selectPlaceholder={t("advanced-search.classroom.forms.campus.select-value.placeholder")}
      loadOptions={loadOptions}
      value={campusOption}
      onChange={onChange}
      notShowLabel
    />
  );
};

export default AdvanceCampusSelector;
